import type { LabResultCategoryKey } from '@liza/fhir-utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The heading for a lab-result category. Category keys live in `@liza/fhir-utils`; their user-facing
 * labels live here, the same split the immunization groups make. Every key is a literal `t` call so
 * extraction keeps both catalogs complete.
 */
export const useLabResultCategoryLabel = (): ((category: LabResultCategoryKey) => string) => {
  const { t } = useTranslation('records');

  return useMemo(() => {
    const labels: Record<LabResultCategoryKey, string> = {
      diabetes: t('labCategoryDiabetes'),
      lipids: t('labCategoryLipids'),
      kidney: t('labCategoryKidney'),
      electrolytes: t('labCategoryElectrolytes'),
      liver: t('labCategoryLiver'),
      bloodCount: t('labCategoryBloodCount'),
      coagulation: t('labCategoryCoagulation'),
      thyroid: t('labCategoryThyroid'),
      ironVitamins: t('labCategoryIronVitamins'),
      inflammation: t('labCategoryInflammation'),
      hormones: t('labCategoryHormones'),
      cardiac: t('labCategoryCardiac'),
      infectious: t('labCategoryInfectious'),
      pulmonary: t('labCategoryPulmonary'),
      other: t('labCategoryOther'),
    };
    return (category: LabResultCategoryKey): string => labels[category];
  }, [t]);
};
